module.exports = __webpack_public_path__ + "static/img/phone2.68a174b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone2.png
// module id = 3zUX
// module chunks = 17